import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';

import React, { Component } from 'react';

import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { clearMessage } from './actions/message';
import AppDefault from './AppDefault';
import { history } from './helpers/history';
import { Role } from './helpers/role';

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentAccount: undefined,
            menu: [],
        };

        history.listen(() => {
            props.dispatch(clearMessage()) // clear message when changing location
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.locale !== this.props.locale) {
            this.createMenu();
        }
    }

    componentDidMount() {
        this.createMenu();
        //this.props.dispatch(connectSocket(Constant.WS_API_BASE + '/api/v1/ws', [], Constant.WS_PREFIX));
        //this.props.dispatch(connectSocket(Constant.WS_API_BASE + '/api/v1/chat', [], Constant.WS_CHAT_PREFIX));
        const account = this.props.account;
        if (account) {
            this.setState({
                currentAccount: account,
            });
        }
    }

    createMenu() {
        const menu = []

        //first group
        let items = []
        if (this.props.account && this.props.account.data.roles.includes(Role.ROLE_USER)) {
            items.push({label: I18n.t('HOME'), icon: 'pi pi-fw pi-home', to: '/'})
            items.push({label: I18n.t('BALANCES'), icon: 'pi pi-fw pi-wallet', to: '/balances'})
            items.push({label: I18n.t('TRANSACTIONS'), icon: 'pi pi-fw pi-angle-double-right', to: '/transactions'})
        }
        if (this.props.account && this.props.account.data.roles.includes(Role.ROLE_MERCHANT)) {
            items.push({label: I18n.t('PAYMENT_LINKS'), to: '/payments', icon: 'pi pi-fw pi-link'})
        }
        menu.push({items: items})

        if (this.props.account && this.props.account.data.roles.includes(Role.ROLE_DEVELOPER)) {
            items = []
            items.push({label: I18n.t('DOCUMENTATION'), to: '/documentation', icon: 'pi pi-fw pi-info-circle'})
            menu.push({items: items})
        }

        this.setState(({
            menu: menu,
        }));
    }

    render() {
        return (
            <AppDefault menu={this.state.menu}/>
        );
    }
}

function mapStateToProps(state) {
    const {account} = state.auth;
    const locale = state.i18n.locale;

    return {
        account,
        locale
    };
}

export default connect(mapStateToProps)(App);

